module.exports = "./img/4c73ed9e0ce090e48b2bd0e07d824571.png";